<script lang="ts">
  import type { Sponsorships, Sponsors } from "$types";
  import YouTube from "$lib/components/episodes/YouTube.svelte";
  import Parameters from "$lib/components/episodes/Parameters.svelte";
  import EpisodeContent from "$lib/components/episodes/EpisodeContent.svelte";
  import Meta from "$components/meta/MetaEpisode.svelte";
  import SponsorGrid from "$components/sponsors/SponsorGrid.svelte";
  import type { SvelteComponent } from "svelte";
  import { Share } from "phosphor-svelte";
  export let data;

  let w: number;

  let video_player: SvelteComponent;

  // format the sponsors for the grid
  let sponsors: Sponsors[] = [];
  data.episode.spin_sponsors?.forEach((sponsorship: Sponsorships) => {
    if (sponsorship.sponsor) sponsors = [...sponsors, sponsorship.sponsor];
  });

  // check if the string contains a "<p>" tag
  let is_html = (str: string) => {
    return str.includes("<p>");
  };

  // check string for line-breaks and add <br> tags
  let add_line_breaks = (str: string) => {
    return str.replace(/\n/g, "<br>");
  };

  const shareData = {
    title: `Craft Roulette - Episode #${data.episode.episode_number}`,
    text: `Episode #${data.episode.episode_number} of weekly improvisational crafting FUNN!`,
    url: `https://craftroulette.live/episodes/episode-${data.episode.episode_number}`,
  };

  const share = async () => {
    try {
      await navigator.share(shareData);
      console.log("share successful");
    } catch (err) {
      console.error(err);
    }
  };
</script>

<svelte:window bind:innerWidth={w} />
{#key data.episode}
  <Meta episode={data.episode} />
{/key}
<EpisodeContent round_top>
  <svelte:fragment slot="content">
    {#if data.episode.youtube_code}
      <YouTube
        code={data.episode.youtube_code}
        context="episode"
        bind:this={video_player}
      />
    {/if}
    {#if data.episode.project && data.episode.colors && data.episode.element && data.episode.random}
      <Parameters
        project={data.episode.project}
        colors={data.episode.colors}
        element={data.episode.element}
        random={data.episode.random}
      />
    {/if}
    <div class="share" role="button" tabindex="0">
      <button
        on:click|stopPropagation={share}
        on:keypress|stopPropagation={share}
      >
        <Share /> Share Episode #{data.episode.episode_number}
      </button>
    </div>
    <div class="stuff">
      {#if data.episode.short_description}
        {#if is_html(data.episode.short_description)}
          {@html data.episode.short_description}
        {:else}
          <p>{@html add_line_breaks(data.episode.short_description)}</p>
        {/if}
      {:else}
        <p>
          Craft Roulette is a weekly YouTube show where crafting projects are
          created live based on 4 random parameters selected by spinning a
          wheel. The projects are improvised, making each episode unique and
          exciting for viewers.
        </p>
      {/if}
    </div>
  </svelte:fragment>
  <svelte:fragment slot="below_content">
    {#if (data.episode.spin_sponsors?.length ?? 0) > 0}
      <div class="inner-heading">
        <h2>Spin Sponsors</h2>
      </div>
      <SponsorGrid {sponsors} />
    {/if}
  </svelte:fragment>
</EpisodeContent>

<style>
.share {
  display: none;
}
@media (max-width: 1024px) {
  .share {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem 1rem 1rem;
  }
  .share button {
    font-weight: bold;
    display: flex;
    align-items: center;
    border: 1px solid var(--dots);
    gap: 1rem;
    padding: 1rem 1.2rem;
    border-radius: 0.5rem;
    background: white;
    box-shadow: var(--shadow);
    color: var(--offDark);
    cursor: pointer;
  }
  .share button:hover {
    background: var(--secondary-dark);
  }
}

.stuff {
  padding: 1.5rem 2rem;
}

@media (max-width: 650px) {
  .stuff {
    padding: 1rem;
  }
}
</style>
